const imageHeader = () => document.querySelector('.sl-image-first')?.classList.toggle('sl-product-scrolled', window.scrollY > 40);
let imageHeaderPending = false;
window.addEventListener('scroll', () => {
  if (imageHeaderPending) return;
  imageHeaderPending = true;
  requestAnimationFrame(() => { imageHeaderPending = false; imageHeader(); });
}, { passive: true });
imageHeader();
document.addEventListener('change', event => {
  if (event.target.matches('[data-sl-country]')) event.target.form.requestSubmit();
  if (event.target.matches('[data-sl-sort-form] input[type=radio]')) event.target.form.requestSubmit();
});
document.addEventListener('click', async event => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-sl-sheet-close],[data-sl-account-open],[data-sl-share],[data-sl-back]');
  if (!button) return;
  if (button.hasAttribute('data-sl-sheet-close')) button.closest('dialog')?.close();
  if (button.hasAttribute('data-sl-account-open')) {
    const dialog = document.querySelector('#SanjarAccount');
    if (!dialog || dialog.open) return;
    dialog.showModal(); dialog.addEventListener('close', () => button.focus({ preventScroll: true }), { once: true });
  }
  if (button.hasAttribute('data-sl-back')) {
    try { if (document.referrer && new URL(document.referrer).origin === location.origin) { event.preventDefault(); history.back(); } } catch {}
  }
  if (button.hasAttribute('data-sl-share')) {
    const url = new URL(location.href); ['preview_theme_id','pb'].forEach(key => url.searchParams.delete(key));
    const status = button.closest('.sl-product-header').querySelector('[data-sl-share-status]');
    try { if (navigator.share) await navigator.share({ title:button.dataset.title, url:url.href });
      else { await navigator.clipboard.writeText(url.href); status.textContent = 'Product link copied'; }
    } catch (error) { if (error.name !== 'AbortError') status.textContent = 'You can copy the product link from your address bar.'; }
  }
});
document.addEventListener('click', event => {
  const dialog = document.querySelector('#SanjarAccount');
  if (dialog?.open && event.target.closest('[data-sl-open],[data-sl-stores-open]')) dialog.close();
});
class SanjarMobileCatalog extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController(); const { signal } = this.abort;
    let saved = '2'; try { saved = sessionStorage.getItem('sanjar-catalog-columns') || '2'; } catch {}
    this.setColumns(saved);
    this.addEventListener('click', event => {
      const button = event.target.closest('button'); if (!button) return;
      if (button.dataset.slColumns) { this.setColumns(button.dataset.slColumns); try { sessionStorage.setItem('sanjar-catalog-columns', button.dataset.slColumns); } catch {} }
      if (button.dataset.slCatalogOpen) { const dialog = this.querySelector(`[data-sl-catalog-sheet="${button.dataset.slCatalogOpen}"]`); if (!dialog?.open) { this.opener=button; dialog?.showModal(); } }
    }, { signal });
    this.querySelectorAll('dialog').forEach(dialog => {
      dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), { signal });
      dialog.addEventListener('click', event => { const r=dialog.getBoundingClientRect(); if(event.target===dialog&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)) dialog.close(); },{signal});
    });
  }
  setColumns(value) {
    const columns = ['1','2','3'].includes(value) ? value : '2'; this.dataset.columns=columns;
    const scope=this.closest('results-list'); if(scope) { scope.dataset.slColumns=columns; if(window.innerWidth < 750) scope.querySelectorAll('.sl-gallery-slide img').forEach(image => image.sizes=`${100/Number(columns)}vw`); }
    this.querySelectorAll('[data-sl-columns]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.slColumns===columns)));
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('sl-mobile-catalog')) customElements.define('sl-mobile-catalog',SanjarMobileCatalog);

// These controls use Shopify's real filter fields; no client-only price filtering.
class SanjarPriceRange extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    this.sliders = [...this.querySelectorAll('[data-sl-range]')];
    const owner = this.dataset.native === 'true' ? this.closest('price-facet-component') : this;
    this.fields = [owner.querySelector(this.dataset.native === 'true' ? '[ref="minInput"]' : '[data-sl-price-field="min"]'), owner.querySelector(this.dataset.native === 'true' ? '[ref="maxInput"]' : '[data-sl-price-field="max"]')];
    this.addEventListener('input', event => {
      if (event.target.matches('[data-sl-range]')) this.sync(event.target, false);
      else if (this.fields.includes(event.target) && event.target.value !== '') {
        this.sliders[this.fields.indexOf(event.target)].value = event.target.value; this.paint();
      }
    }, { signal: this.abort.signal });
    this.addEventListener('change', event => {
      if (event.target.matches('[data-sl-range]')) { event.stopPropagation(); this.sync(event.target, true); }
      else if (this.fields.includes(event.target)) {
        const index=this.fields.indexOf(event.target), slider=this.sliders[index];
        if (event.target.value !== '') { slider.value=event.target.value; this.sync(slider, false); }
      }
    }, { signal: this.abort.signal });
    this.addEventListener('focusout', event => {
      if (this.fields.includes(event.target) && event.target.value !== '') this.sync(this.sliders[this.fields.indexOf(event.target)], false);
    }, { signal: this.abort.signal });
    this.paint();
  }
  sync(slider, notify) {
    const index=slider.dataset.slRange === 'min' ? 0 : 1;
    const other=Number(this.sliders[1-index].value), limit=Number(this.dataset.max);
    let value=Math.min(limit,Math.max(0,Math.round(Number(slider.value)/100)*100));
    value=index === 0 ? Math.min(value,other) : Math.max(value,other);
    slider.value=String(value); this.fields[index].value=String(value); this.paint();
    if(notify) this.fields[index].dispatchEvent(new Event('change',{bubbles:true}));
  }
  paint() {
    this.sliders.forEach(slider => {
      const output=this.querySelector(`[data-sl-range-output="${slider.dataset.slRange}"]`);
      output.textContent=new Intl.NumberFormat(document.documentElement.lang || 'en-IN',{style:'currency',currency:this.dataset.currency || 'INR',maximumFractionDigits:0}).format(Number(slider.value));
    });
    this.style.setProperty('--sl-range-start',`${Number(this.sliders[0].value)/Number(this.dataset.max)*100}%`);
    this.style.setProperty('--sl-range-end',`${Number(this.sliders[1].value)/Number(this.dataset.max)*100}%`);
  }
  disconnectedCallback(){ this.abort?.abort(); }
}
if(!customElements.get('sl-price-range')) customElements.define('sl-price-range',SanjarPriceRange);
document.addEventListener('click',async event => {
  const button=event.target.closest('[data-sl-copy-code]'); if(!button) return;
  const status=button.closest('.sl-product-offers').querySelector('[data-sl-coupon-status]');
  try { await navigator.clipboard.writeText(button.dataset.slCopyCode); status.textContent=`Coupon ${button.dataset.slCopyCode} copied`; button.classList.add('sl-copied'); setTimeout(()=>button.classList.remove('sl-copied'),1500); }
  catch { status.textContent=`Use coupon ${button.dataset.slCopyCode} at checkout, or select Apply offer.`; }
});

// Keep custom product details in sync with the native variant response.
const productDetailUpdates = new WeakMap();
document.addEventListener('shopify:product:select', event => {
 if (!(event.target instanceof Element) || event.target.closest('product-card,quick-add-dialog')) return;
 const scope = event.target.closest('.product-information');
 if (!scope || !event.promise) return;
 const update = (productDetailUpdates.get(scope) || 0) + 1;
 productDetailUpdates.set(scope, update);
 event.promise.then(({ detail }) => {
  if (!scope.isConnected || productDetailUpdates.get(scope) !== update || !detail?.html) return;
  for (const selector of ['.sl-product-facts', '[data-sl-whatsapp]']) {
   const current = scope.querySelector(selector);
   const next = detail.html.querySelector(selector);
   if (current && next) current.replaceWith(next.cloneNode(true));
  }
 }).catch(() => {});
});

// Read the selected native form variant when the customer opens WhatsApp.
document.addEventListener('click', event => {
 const link = event.target.closest('[data-sl-whatsapp-link]');
 if (!link) return;
 const panel = link.closest('[data-sl-whatsapp]');
 const scope = panel.closest('.product-information') || document;
 const selectedId = scope.querySelector('product-form-component form input[name="id"]')?.value || panel.dataset.initialVariant;
 const variants = JSON.parse(panel.querySelector('[data-sl-whatsapp-variants]').textContent);
 const variant = variants.find(item => item.id === selectedId) || variants[0];
 if (!variant) return;
 const photo = variant.image.startsWith('//') ? `https:${variant.image}` : variant.image;
 const title = variant.title === 'Default Title' ? panel.dataset.title : `${panel.dataset.title} — ${variant.title}`;
 const message = `Hello Sanjar, I need help with ${title}\nPrice: ${variant.price}\nProduct: ${panel.dataset.url}?variant=${variant.id}\nPhoto: ${photo}`;
 link.href = `https://wa.me/${panel.dataset.phone}?text=${encodeURIComponent(message)}`;
});
